import axios from '@axios'

export default {
  namespaced: true,
  state: {
    programsList: [],
    programsForSelectList: [],
    program: {},
    manageableProgramId: null,
    manageableProgramLink: null,
  },
  getters: {
    getProgramsList: state => state.programsList,
    getProgramsForSelectList: state => state.programsForSelectList,
    getProgram: state => state.program,
    getManageableProgramId: state => state.manageableProgramId,
    getManageableProgramLink: state => state.manageableProgramLink,
  },
  mutations: {
    SET_ALL_PROGRAMS: (state, data) => {
      state.programsList = data
    },
    SET_PROGRAMS_FOR_SELECT: (state, data) => {
      state.programsForSelectList = data
    },
    SET_PROGRAM: (state, data) => {
      state.program = data
    },
    SET_MANAGEABLE_PROGRAM_ID: (state, data) => {
      state.manageableProgramId = data
    },
    SET_MANAGEABLE_PROGRAM_LINK: (state, data) => {
      state.manageableProgramLink = data
    },
  },
  actions: {
    fetchProgramList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/programs', {
            params: queryParams,
          })
          .then(response => {
            ctx.commit('SET_ALL_PROGRAMS', response.data.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchProgramForSelectList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/programs-for-select', {
            params: queryParams,
          })
          .then(response => {
            ctx.commit('SET_PROGRAMS_FOR_SELECT', response.data.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    async fetchProgramById({ state, commit }, id) {
      if (state.program && state.program.id === id) {
        return state.program
      }

      const { data } = await axios.get(`/programs/${id}`)
      const program = data.data

      commit('SET_PROGRAM', program)

      return program
    },
    fetchProgramBySlug(ctx, slug) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/program-by-slug/${slug}`)
          .then(response => {
            ctx.commit('SET_PROGRAM', response.data.data)
            resolve(response.data.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
